"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var browser_1 = require("@sentry/browser");
var abstract_container_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/abstract_container_store"));
var page_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/page_store"));
var estimate_form_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/estimate_form"));
var form_header_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_header_store"));
var navigation_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/navigation_store"));
var form_inner_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_inner_card_store"));
var item_input_card_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/item_input_card_list_store"));
var form_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_footer_store"));
var input_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input_card_store"));
var user_page_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/import_category_based/user_page_footer_store"));
var barcode_reader_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/barcode_reader_store"));
var campaign_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/campaign_store"));
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var convert_from_input_name_1 = require("@hikakaku/shared/util/convert_from_input_name");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var POST_URL = '/estimate_form/thanks';
var CHECK_URL = '/estimate_form/check';
var WATCH_URL = '/estimate_form/watch';
var WATCH_GROUP_ID = '25';
var ITEM_FORM_API_URL = '/api/estimate_pages/category_bulk/item_form';
var ESTIMATE_DRAFT_API_URL = '/api/estimate/drafts';
var IMPORT_CATEGORY_ID_KEY = 'import_category_id';
var PURCHASE_METHOD_KEY = 'purchase_method';
var MAP_NAME_KEY = 'map_name';
var USER_INPUT_FIELD_SAVE_DRAFT_TARGET_NAMES = [PURCHASE_METHOD_KEY, MAP_NAME_KEY];
var USER_CARD_INPUT_NAME_PREFIX = 'estimate_form[user]';
var PURCHASE_METHOD_PROP_NAME = 'purchase_method';
var CONTACT_PATH = '/お問い合わせ';
var extractPurchaseMethodOptionValues = function (props) {
    var prop = props.find(function (prop) { return prop.name === PURCHASE_METHOD_PROP_NAME; });
    return prop.options.map(function (option) { return option.value; });
};
var ContainerStore = /** @class */ (function (_super) {
    __extends(ContainerStore, _super);
    function ContainerStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = estimate_form_1.default;
        _this.postUrl = POST_URL;
        _this.fetchCategoryItemInputList = function (data) {
            var _a = data.split('/').map(Number), importCategoryId = _a[0], categoryId = _a[1];
            if (!importCategoryId && importCategoryId !== 0) {
                return Promise.resolve(function () { return []; });
            }
            _this.isLoading = true;
            var queryString = window.location.search;
            var params = new URLSearchParams(queryString);
            var key = 'items[][name]';
            var name = params.get(key);
            var query = qs_1.default.stringify((0, convert_case_keys_1.toSnakeKeys)({ estimateForm: { importCategoryId: importCategoryId, categoryId: categoryId, name: name } }));
            return axios_1.default
                .get("".concat(ITEM_FORM_API_URL, "?").concat(query))
                .then(function (response) {
                _this.isLoading = false;
                return function (cardNumber) { return (0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent((0, convert_case_keys_1.toCamelcaseKeys)(response.data)), _this.itemCardInputNamePrefix(cardNumber)); };
            })
                .catch(function (e) {
                window.DialogStore.showErrorDialog();
                (0, browser_1.captureException)(e);
                return function () { return []; };
            });
        };
        _this.itemCardInputNamePrefix = function (cardNumber) {
            return "estimate_form[items][".concat(cardNumber, "]");
        };
        _this.handleClickItemPageNextButton = function () {
            var defaultImportCategoryGroupId = _this.itemCardListStore.defaultImportCategoryGroupId;
            if (defaultImportCategoryGroupId === WATCH_GROUP_ID) {
                var urlParams = new URLSearchParams(window.location.search);
                var kaitoriParam = urlParams.get('kaitori_bonus_campaign_id');
                var destinationUrl = WATCH_URL;
                if (kaitoriParam) {
                    var url = new URL(WATCH_URL, window.location.origin);
                    url.searchParams.set('kaitori_bonus_campaign_id', kaitoriParam);
                    destinationUrl = url.toString();
                }
                window.location.href = destinationUrl;
                return;
            }
            if (!_this.itemCardListStore.validate()) {
                _this.alertStore.alertText = abstract_container_store_1.ALERT_MESSAGE;
                return;
            }
            _this.checkForDuplicateItems(_this.itemCardListStore.values);
        };
        _this.proceedToNextStep = function () {
            _this.updateExpectedStoreSize();
            _this.snsButtonListStore.updateOAuthPaths({
                oauth_redirect: true,
                estimate_draft_identifier: _this.props.estimateDraftIdentifier
            });
            _this.handleClickNextPageButton();
        };
        _this.handleClickAddItemForm = function (importCategoryId) {
            google_analytics_manager_1.default.postGAEvent(String(_this.props.gaEventCategory), '複数カテゴリ査定click', "ImportCategory:".concat(importCategoryId));
        };
        _this.saveDraft = function () {
            var data = new FormData();
            var appendToFormData = function (_a) {
                var name = _a.name, value = _a.value;
                if (value === undefined || value === null) {
                    return;
                }
                if (Array.isArray(value)) {
                    value.forEach(function (v) { return data.append(name, v); });
                }
                else {
                    data.append(name, String(value));
                }
            };
            data.append('form', 'estimate_form');
            data.append('reason', 'abandonment');
            data.append('authenticity_token', _this.props.authenticityToken);
            _this.props.estimateDraftIdentifier && data.append('estimate_form[estimate_draft_identifier]', _this.props.estimateDraftIdentifier);
            _this.props.importCategoryId && data.append('estimate_form[import_category_id]', _this.props.importCategoryId);
            _this.props.importCategoryGroupId && data.append('estimate_form[import_category_group_id]', _this.props.importCategoryGroupId);
            _this.itemCardListStore.values.flatMap(Object.values).forEach(appendToFormData);
            Object.entries(_this.userPageInputCardStore.value).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                USER_INPUT_FIELD_SAVE_DRAFT_TARGET_NAMES.indexOf(key) !== -1 && appendToFormData(value);
            });
            navigator.sendBeacon(ESTIMATE_DRAFT_API_URL, data);
        };
        _this.validate = function () {
            return _this.itemCardListStore.validate() && _this.userPageInputCardStore.validate();
        };
        _this.handleModalButtonClick = function () {
            window.location.href = CONTACT_PATH;
        };
        _this.snsButtonListStore.formPath = POST_URL;
        _this.hiddenFieldInputListStore.addHiddenField({ name: 'authenticity_token', value: props.authenticityToken }, { name: 'estimate_form[ga_event_category]', value: props.gaEventCategory || undefined }, { name: 'estimate_form[original_estimate_entry_id]', value: props.originalEstimateEntryId || undefined }, { name: 'estimate_form[estimate_draft_identifier]', value: props.estimateDraftIdentifier });
        if (props.lpImportCategoryId) {
            _this.hiddenFieldInputListStore.addHiddenField({
                name: 'lp_import_category_id',
                value: String(props.lpImportCategoryId)
            });
        }
        if (props.lpImportCategoryGroupId) {
            _this.hiddenFieldInputListStore.addHiddenField({
                name: 'lp_import_category_group_id',
                value: String(props.lpImportCategoryGroupId)
            });
        }
        if (props.blogId) {
            _this.hiddenFieldInputListStore.addHiddenField({
                name: 'blog_id',
                value: String(props.blogId)
            });
        }
        var formHeaderStore = new form_header_store_1.default({});
        var defaultItemInputProps = props.defaultItemForm
            ? function (cardNumber) { return ((0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent(props.defaultItemForm), _this.itemCardInputNamePrefix(cardNumber))); }
            : undefined;
        _this.itemCardListStore = new item_input_card_list_store_1.default({
            categorySelectorOptions: props.categorySelectorOptions,
            itemCardInputProps: props.itemForms.map(function (itemForm) { return function (cardNumber) { return ((0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent(itemForm), _this.itemCardInputNamePrefix(cardNumber))); }; }),
            fetchCategoryItemInputList: _this.fetchCategoryItemInputList,
            onClickAddItemButton: _this.handleClickAddItemForm,
            defaultImportCategoryGroupId: props.importCategoryGroupId ? String(props.importCategoryGroupId) : undefined,
            defaultImportCategoryId: props.importCategoryId ? String(props.importCategoryId) : undefined,
            defaultItemInputProps: defaultItemInputProps,
            recommendedImportCategoriesDisplayable: true,
            abTestFormsVariant: props.abTestFormsVariant,
            handleClickNextButton: _this.handleClickItemPageNextButton
        });
        var formFooterStore = new form_footer_store_1.default({
            onClickNextButton: _this.handleClickItemPageNextButton,
            description: 'あと少しで入力完了！',
            abTestFormsVariant: props.abTestFormsVariant
        });
        _this.userPageInputCardStore = new input_card_store_1.default({
            title: 'お客様情報',
            inputProps: (0, convert_from_input_name_1.appendPrefixToFormInputNames)(props.userForm, USER_CARD_INPUT_NAME_PREFIX)
        });
        var userPageFooterStore = new user_page_footer_store_1.default({
            onClickSubmitButton: _this.handleClickSubmitButton,
            onClickPrevButton: _this.handleClickPrevPageButton
        });
        _this.updateExpectedStoreSize = function () { return userPageFooterStore.updateExpectedStoreSize(_this.itemCardListStore.values, _this.userPageInputCardStore.value, extractPurchaseMethodOptionValues(props.userForm)); };
        var barcodeReaderStore = new barcode_reader_store_1.default({
            itemInputCardListStore: _this.itemCardListStore
        });
        _this.pageStores = [
            new page_store_1.default({
                elementStores: [
                    formHeaderStore,
                    _this.alertStore,
                    new navigation_store_1.default({ step: 1 }),
                    new form_inner_card_store_1.default({
                        elementStores: [
                            barcodeReaderStore,
                            _this.itemCardListStore,
                            _this.alertStore,
                            formFooterStore
                        ]
                    })
                ]
            }),
            new page_store_1.default({
                elementStores: [
                    formHeaderStore,
                    _this.alertStore,
                    new navigation_store_1.default({ step: 2 }),
                    _this.snsButtonListStore,
                    new form_inner_card_store_1.default({
                        elementStores: [
                            _this.userPageInputCardStore,
                            new campaign_store_1.default({ campaign: props.campaign ? props.campaign : undefined }),
                            _this.alertStore,
                            userPageFooterStore
                        ]
                    })
                ]
            })
        ];
        if (props.snsCampaign) {
            _this.hiddenFieldInputListStore.addHiddenField({ name: 'joining_sns_campaign', value: props.snsCampaign.innerSlug });
        }
        (0, mobx_1.reaction)(function () {
            var _a;
            var _b, _c;
            return (_a = {},
                _a[PURCHASE_METHOD_KEY] = (_b = _this.userPageInputCardStore.findInputStoreByRawName(PURCHASE_METHOD_KEY)) === null || _b === void 0 ? void 0 : _b.value,
                _a[MAP_NAME_KEY] = (_c = _this.userPageInputCardStore.findInputStoreByRawName(MAP_NAME_KEY)) === null || _c === void 0 ? void 0 : _c.value,
                _a);
        }, _this.updateExpectedStoreSize, { fireImmediately: true });
        (0, mobx_1.reaction)(function () { return _this.itemCardListStore.values; }, _this.alertStore.clear);
        (0, mobx_1.reaction)(function () { return _this.isLoading; }, function (isLoading) {
            formFooterStore.isNextButtonEnabled = !isLoading;
            _this.itemCardListStore.isNextButtonDisabled = isLoading;
        });
        (0, mobx_1.reaction)(function () { return _this.isSending; }, function (isSending) { isSending && userPageFooterStore.prepareSubmit(); });
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, function () { barcodeReaderStore.active = false; });
        return _this;
    }
    ContainerStore.prototype.checkForDuplicateItems = function (values) {
        return __awaiter(this, void 0, Promise, function () {
            var names, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        names = values.map(function (item) { return item.name.value; });
                        return [4 /*yield*/, axios_1.default.post(CHECK_URL, { names: names })];
                    case 1:
                        response = _a.sent();
                        response.data.isDuplicate ? this.showModal() : this.proceedToNextStep();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.proceedToNextStep();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return ContainerStore;
}(abstract_container_store_1.default));
exports.default = ContainerStore;
